module.exports = __webpack_public_path__ + "img/l_zuji_on.d9ab162a.png";